import { ErrorContent } from './styles'
import ErrorImageSrc from '../../../../assets/dashboard/error-image.png'

const Error = () => {
  return (
    <ErrorContent>
      <img
        src={ErrorImageSrc}
        alt="Ilustração de uma pessoa interagindo com um painel de informações"
        className="image-svg"
      />
      <div className="text">
        <h2 className="title">Oops!</h2>
        <p className="description">
          Encontramos um erro temporário e não conseguimos concluir o carregamento. Tente novamente
          mais tarde.
        </p>
      </div>
    </ErrorContent>
  )
}

export default Error
